import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const ManualAttributeContext = createContext(null);

type Props = {
  children: ReactElement;
};

const ManualAttributeProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error, reset } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("tm/attributes/upload", payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
      reset,
    }),
    [mutateAsync, data, error, isPending, reset],
  );
  return (
    <ManualAttributeContext.Provider value={contextValue}>
      {children}
    </ManualAttributeContext.Provider>
  );
};

export default ManualAttributeProvider;
